<script setup lang="ts">
import { computed } from "vue";
import Icon from "./Icon.vue";
import { profileTone, type ProfileTone } from "../composables/profileColors";
const props = withDefaults(
  defineProps<{
    name?: string;
    src?: string;
    size?: number;
    group?: boolean;
    /** One of WhatsApp's profile colours; without it, one is derived from the name. */
    tone?: ProfileTone;
    /** A fixed background, for the demo screens. */
    color?: string;
  }>(),
  { size: 48, name: "" },
);
const style = computed(() => {
  const tone = props.tone ?? profileTone(null, props.name);
  return {
    width: props.size + "px",
    height: props.size + "px",
    fontSize: props.size * 0.32 + "px",
    ...(props.color
      ? { background: props.color }
      : {
          background: `var(--wa-profile-surface-${tone})`,
          color: `var(--wa-profile-content-${tone})`,
        }),
  };
});
</script>
<template>
  <span class="avatar" :class="{ photo: src }" :style="style"
    ><img v-if="src" :src="src" :alt="name" /><Icon
      v-else-if="group || !name"
      :name="group ? 'communities' : 'user'"
      :size="size * 0.48"
    /><span v-else>{{
      name
        .split(" ")
        .slice(0, 2)
        .map((n) => n[0])
        .join("")
    }}</span></span
  >
</template>
